import { Button, Stack } from "@mui/material";
import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import {
  CustomeDialog,
  DeleteModal,
  ServerPaginatedtable,
} from "../../../shared";
import { SimpleMenu } from "../../../shared/components";
import { useLabelPrinting } from "../../LabelPrinting/hooks/useLabelPrinting";
import { RecipeLabelCreateOrEdit } from "./RecipeLabelCreateOrEdit";
import { convertStringToTime } from "../../../utils";

export const RecipeLabels = ({ recipeId, basicDetailsQuery }) => {
  const {
    labelPrinting,
    listQuery,
    handleCreateOrEditModal,
    onCreateSubmit,
    onChange,
    onDelete,
    confirmDelete,
    resetDeleteInfo,
    deleteInfo,
    globalData,
    ingredientListQuery,
    recipeListQuery,
    onEditChange,
    moduleSorting,
    modulePagination,
    setModulePagination,
    setModuleSorting,
    validator,
    isCreateVisible,
    isEditable,
    isDeletable,
    labelPrintingDetails,
  } = useLabelPrinting({
    isList: true,
    recipeId,
    type_id: 1,
    item_id: recipeId,
    isLabelprintingList: false,
  });

  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor("variant_name", {
      header: "Variant",
      sortDescFirst: true,
    }),
    columnHelper.accessor("defrosting_time", {
      header: "Defrosting Time Hrs",
      cell: (props) => {
        const { row } = props;
        return convertStringToTime(row.original.defrosting_time, "minute");
      },
    }),
    columnHelper.accessor("freezer_life", {
      header: "Coolroom/Freezer Life Hrs",
      cell: (props) => {
        const { row } = props;
        return convertStringToTime(row.original.freezer_life, "minute");
      },
    }),
    columnHelper.display({
      id: "actions",
      cell: (props) => {
        const { row } = props;
        return (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            gap="8px"
          >
            <SimpleMenu
              row={row}
              editAction={(e) => handleCreateOrEditModal(true, e.id)}
              handleDeleteModal={(e) => onDelete(e.id)}
              isEditable={isEditable}
              isDeletable={isDeletable}
            />
          </Stack>
        );
      },
    }),
  ];

  return (
    <>
      <ServerPaginatedtable
        defaultData={listQuery.data?.label_printing_items ?? []}
        columns={columns}
        headerText="Label Printing"
        emptyMessage="No labels added yet!"
        sorting={moduleSorting}
        setSorting={setModuleSorting}
        pagination={modulePagination}
        setPagination={setModulePagination}
        paginationProps={
          listQuery.data?.pagination || { total: 0, lastPage: 1 }
        }
        isLoading={listQuery?.isLoading}
        rightContent={
          <Stack direction="row" gap="8px">
            {isCreateVisible && (
              <Button
                sx={{
                  height: "36px",
                  border: "1px solid #BCC7DB",
                  borderRadius: "10px",
                  borderColor: "#BCC7DB",
                  color: "#111C2B",
                }}
                type="button"
                size="medium"
                variant="outlined"
                onClick={() => {
                  handleCreateOrEditModal(true, "");
                }}
              >
                Create Label
              </Button>
            )}
          </Stack>
        }
        headerStyle={{
          px: 0,
          fontSize: "18px",
          fontWeight: 500,
          height: "56px",
          py: "12px",
          borderBottom: "1px solid #E0E0E0",
        }}
        headerContentStyle={{ px: 0 }}
        enableTableContainerPaddingBottom
      />

      <CustomeDialog
        open={labelPrinting.openDialog}
        PaperProps={{
          sx: { width: { sm: "482px", xs: "90%" }, minHeight: "400px" },
        }}
        title={labelPrinting.id ? "Edit Label" : "Create Label"}
        divider={false}
        content={
          <RecipeLabelCreateOrEdit
            handleCreateOrEditModal={handleCreateOrEditModal}
            basicDetailsQuery={basicDetailsQuery}
            onCreateSubmit={onCreateSubmit}
            onChange={onChange}
            labelPrinting={labelPrinting}
            isLabelprintingList={false}
            recipeId={recipeId}
            globalData={globalData}
            recipeListQuery={recipeListQuery}
            ingredientListQuery={ingredientListQuery}
            onEditChange={onEditChange}
            validator={validator}
            labelPrintingDetails={labelPrintingDetails}
          />
        }
      />
      <DeleteModal
        open={deleteInfo.show}
        handleClose={() => resetDeleteInfo()}
        onConfirm={() => confirmDelete()}
      />
    </>
  );
};
